export interface DetallesProyecto{
    codigoproyecto: string,
    idunidad?: number,
    nombreunidad: string,
    titulo: string,
    tipoproyecto: string,
    idprogramainvestigacion?: number,
    programainvestigacion: string,
    idprogramavinculo?: number,
    programavinculacion: string,
    tipoFinanciamientoExterno: string,
    tiempoejecucion: string,
    fechainicio: Date,
    fechafin: Date,
    objetivogeneral: string
}

export function getVoidDetallesProyecto():DetallesProyecto{
    return{
        codigoproyecto: "",
        idunidad: 0,
        nombreunidad: "",
        titulo: "",
        tipoproyecto: "",
        idprogramainvestigacion: 0,
        programainvestigacion: "",
        idprogramavinculo: 0,
        programavinculacion: "",
        tipoFinanciamientoExterno: "",
        tiempoejecucion: "",
        fechainicio: new Date(),
        fechafin: new Date(),
        objetivogeneral: ""
    }
}